.action {
  display: flex;
  width: 12px;
  padding: 15px 8px;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  touch-action: none;
  cursor: var(--cursor, pointer);
  border-radius: 5px;
  border: none;
  outline: none;
  appearance: none;
  background-color: transparent;
  margin-right: 4px;
  -webkit-tap-highlight-color: transparent;

  svg {
    color: var(--color-white);
    font-size: 2rem;
  }

  @media (hover: hover) {
    &:hover {
      svg {
        fill: var(--color-grey-17);
      }
    }
  }
}
